import { useEffect, useState } from 'react';

function getViewportWidth() {
  if (typeof window === 'undefined') return 1280;
  return window.innerWidth;
}

export default function useViewport() {
  const [width, setWidth] = useState(getViewportWidth);

  useEffect(() => {
    const onResize = () => setWidth(getViewportWidth());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return {
    width,
    isMobile: width <= 767,
    isTablet: width <= 1023,
    isDesktop: width > 1023,
  };
}
